import React, { useEffect, useState } from 'react';
import SpreadSheetBody from './SpreadSheetBody';
import SpreadSheetHeader from './SpreadSheetHeader';
import { Scroller } from '../';
;
export var SpreadSheet = function (_a) {
    var id = _a.id, data = _a.data, loading = _a.loading, columns = _a.columns;
    var _b = useState(0), contentUpdated = _b[0], setContentUpdated = _b[1];
    var containerId = id || 'sheets-container';
    /**
     * Sets the call in progress to false on receiving data
     */
    useEffect(function () {
        setContentUpdated(function (old) { return old + 1; });
    }, [data]);
    return (React.createElement("div", { className: "sheet-parent-container", id: containerId },
        React.createElement(Scroller, { id: "sheets-scroller", className: "custom-scroll", contentUpdated: contentUpdated, primarySelector: ".sheet-container", childrenSelectors: [
                '.sheet-head-container',
                '.sheet-container'
            ] },
            React.createElement(SpreadSheetHeader, { data: data, columns: columns }),
            React.createElement(SpreadSheetBody, { id: containerId, data: data, loading: loading, columns: columns }))));
};
export * from './types';
